import { getCLS, getFCP, getFID, getLCP, getTTFB } from 'web-vitals';

const reportWebVitals = (onPerfEntry = console.info) => {
  if (onPerfEntry && onPerfEntry instanceof Function) {
    getCLS(onPerfEntry);
    getFCP(onPerfEntry);
    getFID(onPerfEntry);
    getLCP(onPerfEntry);
    getTTFB(onPerfEntry);
  }
};

export default reportWebVitals;
